export default "__VITE_ASSET__DcmMZkr3__"